import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modify" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, {
      class: "dropdown pointer",
      style: {"margin-left":"auto"},
      placement: "top",
      trigger: "click",
      teleported: false,
      "popper-class": "chats-dropdown-edit",
      onVisibleChange: _cache[0] || (_cache[0] = $event => ($data.visible = $event))
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "Modify the answer", -1 /* HOISTED */)),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.ACTIONS, (action) => {
              return _createVNode(_component_el_dropdown_item, {
                key: action.name,
                class: "item",
                onClick: $event => (_ctx.$emit('ask-ai', {text: action.prompt}))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    icon: action.icon,
                    width: "1.6rem",
                    height: "1.6rem",
                    "stroke-width": "1.2"
                  }, null, 8 /* PROPS */, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(action.name), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      default: _withCtx(() => [
        ($data.visible)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              hover: "",
              icon: "menu-04",
              stroke: "var(--gray-700)",
              "stroke-width": "1",
              width: "1.6rem",
              height: "1.6rem"
            }))
          : (_openBlock(), _createBlock(_component_Tooltip, {
              key: 1,
              text: "Modify"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  hoverable: "",
                  icon: "menu-04",
                  stroke: "var(--gray-700)",
                  "stroke-width": "1",
                  width: "1.6rem",
                  height: "1.6rem",
                  hover: $data.visible
                }, null, 8 /* PROPS */, ["hover"])
              ]),
              _: 1 /* STABLE */
            }))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}